import React, { useState, useEffect } from "react";
import Icon from "../../assets/icons/Icon";

const FloatingButton = () => {
  const [showUp, setShowUp] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const windowHeight = window.innerHeight;
      const docHeight = document.documentElement.scrollHeight;

      // midpoint position
      const halfWay = (docHeight - windowHeight) / 2;

      // If scroll is beyond halfway, show UP arrow
      setShowUp(scrollTop > halfWay);
    };

    handleScroll(); // run once
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const scrollToBottom = () => {
    window.scrollTo({ top: document.body.scrollHeight, behavior: "smooth" });
  };

  return (
    <div className="float-container">
      <div className="float-buttons">
        {showUp ? (
          <span onClick={scrollToTop} className="float-btn">
            <Icon name="FaAngleUp" className="icon_main" />
          </span>
        ) : (
          <span onClick={scrollToBottom} className="float-btn">
            <Icon name="FaAngleDown" className="icon_main" />
          </span>
        )}
      </div>
    </div>
  );
};

export default FloatingButton;
